<div>
  <form
    [formGroup]="form"
    class="box-border items-center rounded-[8px]"
    #textareaFieldElement
    (submit)="onSubmit()"
  >
    <div class="flex justify-between items-center mb-2">
      <ui-headline
        type="h12"
        mobile-type="h12"
        font-weight="semibold"
        text-color="neutrals-900"
      >
        {{ title }}
      </ui-headline>
      <button
        *ngIf="editNote"
        type="submit"
        class="flex flex-col items-center justify-center w-7 h-7 rounded-[6px]"
        [ngClass]="{
          'bg-[#FFC2C6]': !form.valid,
          'bg-unicon-yellow-100': form.valid,
        }"
        matTooltip="Guardar cambio"
      >
        <ui-icon
          *ngIf="!loading"
          name="check"
          fill="neutrals-900"
          size="20"
          mSize="20"
        />
        <ui-loader *ngIf="loading" type="secondary" size="md" />
      </button>
    </div>
    <mat-form-field appearance="outline" class="custom-textarea">
      <textarea
        matInput
        formControlName="textarea"
        placeholder="Escribe tus anotaciones privadas a ti. "
        rows="4"
        (focus)="onFocusTextarea()"
      ></textarea>
    </mat-form-field>
  </form>
</div>
